import React, { useState } from "react";
import { MenuItem } from "@showitinc/showit-wc";
import AppConstants from "../../../constants/AppConstants";
import ContextMenuWrapper from "../../../app2components/ContextMenus/ContextMenuWrapper";
import SiteDesignStore from "../../../stores/SiteDesignStore";
import UIActions from "../../../actions/UIActions";
import uiPrefix from "../../../utils/UiPrefixUtils";

const { ITEM_TYPE_CANVAS_SET, CONTEXT_ITEM_BUTTON } = AppConstants;

/**
 * Context menu for the canvas-set section header in the layers sidepanel.
 *
 * @component
 * @param {Object} props
 * @param {import("immutable").Map} props.blockContainer - The active block container.
 */
const LayerPanelSiteCanvasSetMenu = ({ blockContainer }) => {
  const canvasSetId = blockContainer.getIn(["currentPageItem", "canvasSet", 0]);
  const [canvasSet] = useState(SiteDesignStore.findCanvasSet(canvasSetId));

  const _selectCanvasSet = () => {
    UIActions.selectCanvasSet({ canvasSet });
    UIActions.addActiveItemHistory({
      id: canvasSet.get("id"),
      type: ITEM_TYPE_CANVAS_SET,
      name: canvasSet.get("name"),
    });
  };

  return (
    <ContextMenuWrapper icon="menuMoreHoriz" active>
      <MenuItem
        data-e2e={uiPrefix(`edit-site-canvas-${CONTEXT_ITEM_BUTTON}`)}
        onClick={_selectCanvasSet}
      >
        Edit Site Canvas Set
      </MenuItem>
    </ContextMenuWrapper>
  );
};

export default LayerPanelSiteCanvasSetMenu;
